<template>
  <v-card elevation="7">
    <v-row clas="bm-0 mb-0 pb-0">
      <v-col cols="12">
        <v-card-subtitle class="ml-2">
          <h2 class="text-uppercase indigo--text">
            {{ currentUser.nombre }} {{ currentUser.primer_apellido }}
            {{ currentUser.segundo_apellido }}
          </h2>
          <h4 class="text-uppercase" style="color: #616161">
            {{ currentUser.roles[0].descripcion }}
          </h4>
          <v-divider class="mt-3"/>
          <div align="center" class="font-weight-bold mt-6">
            <h1>DOCUMENTOS</h1>
            <v-btn
              small
              class="white--text mt-n6"
              style="float: right;"
              color="#276090"
              @click="$router.push({ name:'SecAcuerdosIndex' })"
            ><v-icon class="mr-2">mdi-arrow-left</v-icon>REGRESAR
            </v-btn>
          </div>
        </v-card-subtitle>
      </v-col>
      <v-divider></v-divider>
    </v-row>
    <ListDocumentos
      v-if="apelacion"
      ref="documentos"
      :cuenta="cuenta_detalles"
      :apelacion="apelacion"
      :role="roleUser"
    >
    </ListDocumentos>

  </v-card>
</template>

<script>
  import { mapMutations } from "vuex";
  import { mapGetters } from "vuex";
  import ListDocumentos from "@/components/ListDocumentos";

  export default {
    components: {
      ListDocumentos
    },
    props: {
      source: String
    },
    data() {
      return {
        apelacion: null,
        cuenta_detalles: null,
        apelacion_id:'',
        listDocumentos: [],
      };
    },
    computed: {
      ...mapGetters(["roleUser", 'currentUser'])
    },
    created() {
      this.apelacion_id = JSON.parse(localStorage.getItem('currentApelacion'));
      this.getApelacion();
    },
    methods: {
      getApelacion(){
        this.$store.dispatch("SHOW_APELACION",  {
          url: '/apelacion/' + this.apelacion_id
        }).then(response => {
          this.apelacion = response.data.data.apelacion
        }).catch(err => {
          console.log(err);
        });
      },
    }
  };
</script>
